import { useMutation, useQuery } from "@tanstack/react-query";
import { ServiceRequestDto, ServiceRequestActionDto, ServiceRequestCommentDto, ServiceRequestSearchDto } from "../../services/dto";
import { IActionResponse, IActionResult } from "../../assets/utils/lib";
import { ServiceRequestClient } from "../../services/proxies/admin/serviceRequestClient";
import { Constants } from "../../assets/utils/lib/constants";

export namespace ServiceRequestService {
  const serviceRequestClient = new ServiceRequestClient();

  export const save = () =>
    useMutation<IActionResult<ServiceRequestDto>, Error, ServiceRequestDto>({
      mutationFn: async (payload: ServiceRequestDto) => {
        return await serviceRequestClient.saveServiceRequestAsync(payload);
      },
    });

  export const addNote = () =>
    useMutation<
        IActionResult<ServiceRequestCommentDto>,
      Error,
        ServiceRequestCommentDto
    >({
        mutationFn: async (payload: ServiceRequestCommentDto) => {
        return await serviceRequestClient.addNoteAsync(payload);
      },
    });

  export const completeRequest = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (id: string | undefined) => {
        return await serviceRequestClient.completeRequestAsync(id);
      },
    });

  export const closeRequest = () =>
    useMutation<IActionResponse, Error, string>({
      mutationFn: async (id: string | undefined) => {
        return await serviceRequestClient.closeRequestAsync(id);
      },
    });

  export const getServiceRequestQuery = (id: string | undefined, enabled: boolean = true) =>
    useQuery({
      queryKey: ["serviceRequestQuery", id],
      queryFn: async () =>
        await serviceRequestClient.getServiceRequestAsync(id),
      enabled: enabled && Boolean(id && id !== Constants.emptyGuid),
    });

  export const gridQuery = (searchQuery: ServiceRequestSearchDto, enabled: boolean = true) =>
    useQuery({
      queryKey: ["serviceRequestGridQuery", searchQuery],
      queryFn: async () =>
        await serviceRequestClient.searchServiceRequestsAsync(searchQuery),
      enabled: enabled,
    });

  export const getLookupsQuery = (enabled: boolean = true) =>
    useQuery({
      queryKey: ["serviceRequestLookupsQuery"],
      queryFn: async () => await serviceRequestClient.getLookupsAsync(),
      enabled: enabled,
    });

  export const dashboardCountsQuery = (enabled: boolean = true) =>
    useQuery({
      queryKey: ["serviceRequestDashboardCountsQuery"],
      queryFn: async () => await serviceRequestClient.getDashboardCountsAsync(),
      enabled: enabled,
    });

    export const getServiceRequestNotes = (id: string | undefined, enabled: boolean = true) =>
        useQuery({
            queryKey: ["getServiceRequestNotes", id],
            queryFn: async () =>
                await serviceRequestClient.getServiceRequestNotesAsync(id),
            enabled: enabled && Boolean(id && id !== Constants.emptyGuid),
        });

    export const getServiceRequestActions = (id: string | undefined, enabled: boolean = true) =>
        useQuery({
            queryKey: ["getServiceRequestActions", id],
            queryFn: async () =>
                await serviceRequestClient.getServiceRequestActionsAsync(id),
            enabled: enabled && Boolean(id && id !== Constants.emptyGuid),
        });
}


